import React, { useState } from 'react';
import { useToasts } from 'react-toast-notifications';

import { useFirebase } from '../../hooks';

export default function CelebrityItem() {
  const [loading, setLoading] = useState(false);
  const [adsenseStatus, setAdsenseStatus] = useState(false);
  const firebase = useFirebase();
  const { addToast } = useToasts();

  // AdSense durumunu kontrol et
  React.useEffect(() => {
    const status = localStorage.getItem('adsenseApproved') === 'true';
    setAdsenseStatus(status);
  }, []);

  async function handleCreateLevels() {
    setLoading(true);
    try {
      await firebase.createLevels();
      addToast('Levels have been created.', {
        appearance: 'success',
        autoDismiss: true,
      });
    } catch (error) {
      addToast(error.message, {
        appearance: 'error',
        autoDismiss: true,
      });
    } finally {
      setLoading(false);
    }
  }

  function handleAdsenseToggle() {
    const newStatus = !adsenseStatus;
    setAdsenseStatus(newStatus);
    localStorage.setItem('adsenseApproved', newStatus.toString());
    
    // Sayfayı yenile ki değişiklik etkili olsun
    window.location.reload();
    
    addToast(`AdSense durumu ${newStatus ? 'aktif' : 'pasif'} olarak ayarlandı.`, {
      appearance: 'success',
      autoDismiss: true,
    });
  }

  return (
    <div className="container mt-2">
      <div className="row mb-3">
        <div className="col">
          <h3>Admin Panel</h3>
        </div>
      </div>
      
      <div className="row mb-3">
        <div className="col">
          <h5>AdSense Yönetimi</h5>
          <div className="form-check form-switch">
            <input
              className="form-check-input"
              type="checkbox"
              id="adsenseToggle"
              checked={adsenseStatus}
              onChange={handleAdsenseToggle}
            />
            <label className="form-check-label" htmlFor="adsenseToggle">
              AdSense Reklamları {adsenseStatus ? 'Aktif' : 'Pasif'}
            </label>
          </div>
          <small className="text-muted">
            {adsenseStatus 
              ? 'Ana sayfada reklam alanı görüntüleniyor, normal boşluk.' 
              : 'Ana sayfada reklam alanı gizli, azaltılmış boşluk.'}
          </small>
        </div>
      </div>

      <div className="row">
        <div className="col">
          <button className="btn btn-primary" onClick={handleCreateLevels}>
            {loading ? (
              <>
                <span
                  className="spinner-grow spinner-grow-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                <span className="sr-only">Loading...</span>
              </>
            ) : (
              'Create Levels'
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
